import {
  API_CRM_GROUP_MANAGE
} from 'constants/ApiUrls'
import { METHOD_PUT } from 'constants/Methods'
import { createApi } from 'utils/index'

export const getSettings = ({ group_id: groupId = 'none', consume = false }) => createApi(`${API_CRM_GROUP_MANAGE}/${groupId}${consume ? '?consume' : ''}`)
export const updateSettings = ({ group_id: groupId, data }) => createApi(`${API_CRM_GROUP_MANAGE}/${groupId}`, METHOD_PUT, data)
